module.exports = __webpack_public_path__ + "@/assets/img/repayment.61572bda.gif";